<template>
  <QueryView
    ref="queryView"
    :table-config="tableConfig"
    :highway-selection-options="highways"
    :town-selection="false"
    :region-selection="false"
    :province-selection="false"
    use-expansion
  >
    <template #expansion="{ data }">
      <div class="query__expansion-container">
        <QueryExpansionField
          field-name="Café"
          :field-value="data.cafe"
          field-type="bool"
        />
        <QueryExpansionField
          field-name="Gasolinera"
          :field-value="data.fuelStation"
          field-type="bool"
        />
        <QueryExpansionField
          field-name="Teléfono"
          :field-value="data.phone"
          field-type="bool"
        />
        <QueryExpansionField
          field-name="Restaurante"
          :field-value="data.restaurant"
          field-type="bool"
        />
        <QueryExpansionField
          field-name="Hotel"
          :field-value="data.hotel"
          field-type="bool"
        />
        <QueryExpansionField
          field-name="Tienda"
          :field-value="data.shop"
          field-type="bool"
        />
      </div>
    </template>
  </QueryView>
</template>

<script setup>
import {ref, onMounted} from 'vue';
import {useClipboard} from '@vueuse/core';
import QueryView from '../QueryView';
import QueryExpansionField from '@/components/query-expansion-field/QueryExpansionField';
import QueryTableConfig from '../query-table.view-config.js';
import {SERVICE_AREAS_SCHEMA} from './query-service-areas-table.view-config';
import {
  searchServiceArea,
  getAllServiceAreaHighways,
} from '@/api/service-area/service-area.api';
import {
  searchServiceAreaHtml,
  searchServiceAreaPdf,
  getServiceAreaPdf,
} from '@/api/service-area/service-area.api.pdf.js';
import useHandleMOCError from '@/composables/use-handle-moc-error';
import {errorToastOptions} from '@/util-toast';
// #region Props, Emits

// #endregion

// #region Params, Ref, Reactives, Computed
const {handleMOCError} = useHandleMOCError();
const highways = ref([]);
const queryView = ref();
const {copy} = useClipboard();
//  #endregion

// #region Functions
async function printServiceArea(data) {
  const printRecord = queryView?.value?.printRecord ?? null;
  if (!!printRecord) {
    await printRecord(
      data.id,
      'Área de servicio - ' + data.name,
      getServiceAreaPdf,
    );
  }
}
async function htmlServiceAreaQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Área de servicio', searchServiceAreaHtml, 'html');
  }
}
async function printServiceAreaQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Área de servicio', searchServiceAreaPdf);
  }
}
async function goServiceArea({coordinates, name, visible}) {
  const goCoordinates = queryView?.value?.goCoordinates;
  const zoom = 13;
  if (!!goCoordinates) {
    goCoordinates({coordinates, name, visible, zoom});
  }
}
function serviceAreaToText({
  name,
  highway,
  route,
  km,
  cafe,
  fuelStation,
  phone,
  restaurant,
  shop,
  hotel,
}) {
  const cafeStr = !!cafe ? 'Sí' : 'No';
  const fuelStationStr = !!fuelStation ? 'Sí' : 'No';
  const phoneStr = !!phone ? 'Sí' : 'No';
  const restaurantStr = !!restaurant ? 'Sí' : 'No';
  const shopStr = !!shop ? 'Sí' : 'No';
  const hotelStr = !!hotel ? 'Sí' : 'No';
  const res = `
    Nombre: ${name}
    Autopista: ${highway}
    Recorrido: ${route}
    Km: ${km}
    Café: ${cafeStr}
    Gasolinera: ${fuelStationStr}
    Teléfono: ${phoneStr}
    Restaurante: ${restaurantStr}
    Hotel: ${hotelStr}
    Tienda: ${shopStr}
    `;
  return res;
}
// #endregion
// functions previously defined
const tableConfig = new QueryTableConfig({
  title: '',
  api: searchServiceArea,
  recordToText: serviceAreaToText,
  copyClipboard: copy,
  htmlQuery: htmlServiceAreaQuery,
  printQuery: printServiceAreaQuery,
  printRecord: printServiceArea,
  centerMap: goServiceArea,
  schema: SERVICE_AREAS_SCHEMA,
});
// #region Effects, Hooks
onMounted(async () => {
  try {
    const {data} = await getAllServiceAreaHighways();
    highways.value = data;
  } catch (err) {
    const errorHighways = errorToastOptions(
      'Error',
      'Error al cargar las autopistas',
    );
    return handleMOCError(err, errorHighways);
  }
});
// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped></style>
